<script>
import { mapState, mapActions, mapGetters } from "vuex";
import ClientFactory from "@/api/ClientFactory";
import { VueGoodTable } from 'vue-good-table';
const dropdownsApi = ClientFactory.get("dropdowns");

const emulationApi = ClientFactory.get("emulations");

export default {
  components: {
      VueGoodTable
  },
  data(){
    return {
      total: 0,
      id: 0,
      group_name:"",
      group_name_create:"",
      group_name_edit:"",
      status: 1,
      columns: [
        {
          label: 'Tên nhóm thi đua',
          field: 'group_name',
          thClass: 'emu-vgt-thead-th text-center',
          tdClass: 'emu-vgt-tbody-td',
        },
        {
          label: 'Thao tác',
          field: 'action',
          thClass: 'emu-vgt-thead-th text-center',
          tdClass: 'emu-vgt-tbody-td text-center',
          width: '250px',
        },
      ],
       data: [
      ],
      group_emulation:[
      ],
      years: [],
      employee_columns:[
          {
            label: 'Họ và tên',
            field: 'full_name',
            thClass: 'emu-vgt-thead-th text-center',
            tdClass: 'emu-vgt-tbody-td',
          },
          {
            label: 'Chọn',
            field: 'action',
            thClass: 'emu-vgt-thead-th text-center',
            tdClass: 'emu-vgt-tbody-td',
            width: '70px'
          }
        ],
      target_columns: [
        {
          label: 'Chọn',
          field: 'action',
          thClass: 'text-center width-class',
          tdClass: 'text-center width-class',
        },
        {
          label: 'Tiêu chí/Nội dung',
          field: 'target_name',
          thClass: 'text-center',
          tdClass: 'text-left',
        },
        {
          label: 'Thang điểm',
          field: 'point',
          headerField: this.sumCount,
          thClass: 'text-center width-point',
          tdClass: 'text-center width-point',
        },
      ],
      employee_data:[],
      employee_data_update:[],
      target_data:[],
      target_data_update:[],
      state: {
          dialog: {
              detail: false,
              create:false,
              update:false,
              delete: false,
              user:false,
              target:false,
          }
      },
    };
  },
  async created() {
    this.getGroup();
  },
  methods: {
     ...mapActions("ui", ['loading', 'closeLoading', 'notify']),
    getGroup: async function () {
      this.loading(this.$vs);
      const { data } = await emulationApi.getGroup(0,this.group_name,this.status);
      console.log(data);
      this.closeLoading();
      this.checkResponseData(data);
    },

    checkResponseData(data) {
      if(data.status == "success")
      { 
        if(data.data[0].id != undefined)
          this.data = data.data;
        else
          this.data = [];

      }else{
        this.notify({
          error:true,
          title: data.status,
          text: data.message
        });
      }
    },

    rowStyleClassFn(row) {
      return row.is_title > 0 ? 'header-row' : '';
    },

    displayDeleteGroup(id) {
        this.state.dialog.delete = true;
        this.id = id;
    },
    displayUpdateGroup(id,group_name) {
        this.state.dialog.update = true;
        this.id = id;
        this.group_name_edit = group_name;
    },
    displayCreateGroup() {
        this.state.dialog.create = true;
    },
    async displayUserGroup(id){
        const { data } =await emulationApi.getGroupUser(id);
        this.id = id;
        this.employee_data_update = data.data[0].departments;
        this.employee_data = JSON.parse(JSON.stringify(this.employee_data_update));
        this.state.dialog.user = true;
    },

    async displayTargetGroup(id){
        const { data } = await emulationApi.getGroupTarget(id);
        this.id = id;
        this.target_data_update = data.data[0].title_targets;
        this.target_data = JSON.parse(JSON.stringify(this.target_data_update));
        this.state.dialog.target = true;
        //console.log(data);
    },

    async createGroup() {
      const response = await emulationApi.insertGroup({
        group_name:this.group_name_create,
        status:1
      });
      if(typeof response.error !== 'undefined') {
          return this.notify({
              error: true,
              text: response.error
          })
      }
      this.notify({
              success: true,
              text: "Thêm mới thành công"
      })
      this.state.dialog.create = false;
      // reload emulations
      await this.getGroup();
    },
    async updateGroup(groupId) {
      const response = await emulationApi.updateGroup({
        id:groupId,
        group_name:this.group_name_edit,
        status:1
      });
      if(typeof response.error !== 'undefined') {
          return this.notify({
              error: true,
              text: response.error
          })
      }
      this.notify({
              success: true,
              text: "Cập nhật thành công"
      })
      this.state.dialog.update = false;
      // reload emulations
      await this.getGroup();
    },
    async deleteGroup(groupId) {
      const response = await emulationApi.deleteGroup(groupId);
      if(typeof response.error !== 'undefined') {
          return this.notify({
              error: true,
              text: response.error
          })
      }
      this.state.dialog.delete = false;
      // reload emulations
      await this.getGroup();
    },

    checkGroupUser(userID){
      for (let i = 0; i < this.employee_data.length; i++) {
        let index = this.employee_data[i].children.findIndex(c => c.employee_id === userID);
        if(index > -1) {
          this.employee_data[i].children[index].checked = !this.employee_data[i].children[index].checked;
          return;
        }
      }
    },
    checkTarget(row){
      let index = this.target_data.findIndex(c => c.target_id === row.target_parent_id);
      if(index > -1) {
          const indexChildren = this.target_data[index].children.findIndex(c => c.target_id === row.target_id);
          //console.log("indexChildren= " + indexChildren);
          if(indexChildren > -1) {
            this.target_data[index].children[indexChildren].checked = !this.target_data[index].children[indexChildren].checked;
            this.target_data[index].children[indexChildren].point = parseInt(row.point);
          }
          //Tính tổng gán vào title
          let sum = 0;
          this.target_data[index].children.forEach(x => {
              sum += x.point;
          });
          //console.log(sum);
          this.target_data[index].point =sum;
      }
    },

    sumCount: function (rowObj) {
      let sum = 0;
      for (let i = 0; i < rowObj.children.length; i++) {
        if(rowObj.children[i].checked)
          sum += parseInt(rowObj.children[i].point);
      }
      return sum;
    },

    async saveGroupUser(){
      let jsonUser=[];
      //console.log(this.employee_data);
      this.employee_data.forEach(row =>{
        row.children.forEach(user=>{
          if(user.checked){
            jsonUser.push({employee_id:user.employee_id});
          }
        })
      })
      let data = {
        emulation_group_id:this.id,
        employees:jsonUser
      }

      const response = await emulationApi.insertGroupUser(data);
      if(typeof response.error !== 'undefined') {
          return this.notify({
              error: true,
              text: response.error
          })
      }
      this.notify({
              success: true,
              text: "Cập nhật thành công"
      })
      this.state.dialog.user = false;
    },

    async saveGroupTarget(){
      let jsonTarget=[];
      let totalPoint = 0;
      console.log(this.target_data);
      this.target_data.forEach(row =>{
        let countCheck = 0;
        row.children.forEach(target=>{
          if(target.checked){
            jsonTarget.push({
              emulation_target_id: target.target_id,
              point: target.point
            });
            totalPoint += target.point;
            countCheck++;
          }
        })
        if(countCheck > 0){
          jsonTarget.push({
              emulation_target_id: row.target_id,
              point: row.point
          });
        }
      })
      let data = {
        emulation_group_id:this.id,
        targets:jsonTarget
      }
      console.log(data);
      if(totalPoint !== 100) {
          return this.notify({
              error: true,
              text: `Tổng điểm phải bằng 100 điểm, Vui lòng thao tác lại!\nĐiểm hiện tại: ${totalPoint} điểm`
          })
      }

      const response = await emulationApi.insertGroupTarget(data);
      console.log(response);
      if(typeof response.error !== 'undefined') {
          return this.notify({
              error: true,
              text: response.error
          })
      }
      this.notify({
              success: true,
              text: "Cập nhật thành công"
      })
      this.state.dialog.user = false;
    },
    changePoint(row){
      console.log("changePoint");
      let index = this.target_data.findIndex(c => c.target_id === row.target_parent_id);
      if(index > -1) {
          const indexChildren = this.target_data[index].children.findIndex(c => c.target_id === row.target_id);
          //console.log("indexChildren= " + indexChildren);
          if(indexChildren > -1) {
            this.target_data[index].children[indexChildren].point = parseInt(row.point);
          }
          //Tính tổng gán vào title
          let sum = 0;
          this.target_data[index].children.forEach(x => {
              sum += x.point;
          });
          //console.log(sum);
          this.target_data[index].point =sum;
      }
    },
    searchGroup(){
      this.getGroup();
    }
  },
  computed: {
    ...mapState("auth", ["AppActiveUser"]),
  },
  destroyed() {
    this.closeLoading();
  }
};

</script>

<template>
  <div class="emulation_group">
    <CCard title="Quản lý nhóm thi đua" class="mb-2">
      <CCardHeader class="emu-card-header-title pt-1 pb-1">
           <h4>Quản lý nhóm thi đua</h4>
      </CCardHeader>
      <CCardBody class="pt-1 pb-1">
        <CRow>
            <CCol sm="1"/>
            <CCol sm="6">
              <label class='mb-0'>Tên nhóm thi đua</label>
              <CInput
                :value.sync="group_name"
                class=" pt-1"
                />
            </CCol>
            <CCol sm="4" style="padding-top:20px">
                <vs-button warn square class="float-left custom_btn_search"  @click="searchGroup()"><i class='bx bx-search'></i>&nbsp;Tìm kiếm</vs-button>
                <vs-button square class="float-left" @click="displayCreateGroup()" ><i class='bx bxs-plus-square' ></i>&nbsp;Tạo mới</vs-button>
            </CCol>
            <CCol sm="1"/>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard>
        <vue-good-table
          :columns="columns"
          :rows="data"
          compactMode
          :sort-options="{
            enabled:false
          }"
          :pagination-options="{
              enabled: true,
              perPageDropdownEnabled: false,
              nextLabel: 'Trang sau',
              prevLabel: 'Trang trước',
              ofLabel: 'của',
          }"
          :line-numbers="true"
          :row-style-class="rowStyleClassFn"
        >
          <div slot="emptystate">
            Không có dữ liệu
          </div>
          <template
            slot="table-row"
            slot-scope="props"
          >
              <div v-if="props.column.field === 'action'" class="row center">
                    <vs-tooltip color="square">
                      <vs-button transparent @click="displayUpdateGroup(props.row.id,props.row.group_name)"  square circle icon><i class='bx bxs-edit' ></i></vs-button>
                        <template #tooltip>
                            Chỉnh sửa
                        </template>
                    </vs-tooltip>
                    <vs-tooltip color="success">
                      <vs-button transparent @click="displayUserGroup(props.row.id)"  success circle icon><i class='bx bxs-user-account' ></i></vs-button>
                        <template #tooltip>
                            Gán người dùng vào nhóm
                        </template>
                    </vs-tooltip>
                    <vs-tooltip color="warn">
                      <vs-button transparent @click="displayTargetGroup(props.row.id)"  warn circle icon><i class='bx bx-right-indent' ></i></vs-button>
                        <template #tooltip>
                            Gán chỉ tiêu vào nhóm
                        </template>
                    </vs-tooltip>
                    <vs-tooltip color="danger">
                        <template #tooltip>
                            Xóa chấm điểm
                        </template>
                        <vs-button transparent @click="displayDeleteGroup(props.row.id)" gradient danger circle icon><i class='bx bx-trash'></i></vs-button>
                    </vs-tooltip>
              </div>
              
          </template>
        </vue-good-table> 
    </CCard>

    <vs-dialog prevent-close width="550px" v-model="state.dialog.create">
        <template #header>
            <h4 class="not-margin">
                Thêm mới
            </h4>
        </template>
        <!-- <template #body> -->
            <label class='mb-0'>Tên nhóm thi đua</label>
              <CInput
                :value.sync="group_name_create"
                class=" pt-1"
                />
        <!-- </template> -->
        <template #footer>
            <div class="con-footer flex flex-end">
                <vs-button transparent @click="createGroup()">
                    Thêm mới
                </vs-button>
                <vs-button @click="state.dialog.create = false" dark transparent>
                    Hủy
                </vs-button>
            </div>
        </template>
    </vs-dialog>

    <vs-dialog prevent-close width="550px" v-model="state.dialog.update">
        <template #header>
            <h4 class="not-margin">
                Chỉnh sửa
            </h4>
        </template>
        <!-- <template #body> -->
            <label class='mb-0'>Tên nhóm thi đua</label>
              <CInput
                :value.sync="group_name_edit"
                class=" pt-1"
                />
        <!-- </template> -->
        <template #footer>
            <div class="con-footer flex flex-end">
                <vs-button transparent @click="updateGroup(id)">
                    Cập nhật
                </vs-button>
                <vs-button @click="state.dialog.update = false" dark transparent>
                    Hủy
                </vs-button>
            </div>
        </template>
    </vs-dialog>
    
    <vs-dialog prevent-close width="550px" v-model="state.dialog.delete">
      <template #header>
          <h4 class="not-margin">
              Xác nhận
          </h4>
      </template>
      Bạn có chắc chắn muốn xóa khỏi hệ thống?
      <template #footer>
          <div class="con-footer flex flex-end">
              <vs-button transparent @click="deleteGroup(id)">
                  Xóa
              </vs-button>
              <vs-button @click="state.dialog.delete = false" dark transparent>
                  Hủy
              </vs-button>
          </div>
      </template>
    </vs-dialog>

    <vs-dialog prevent-close class="employee-dialog" width="650px" v-model="state.dialog.user">
      <CCard  class="pb-0">
        <CCardHeader class="pt-0 pb-0">
            <h4>Danh sách người dùng</h4>
        </CCardHeader>
        <CCardBody  class="pt-2 pb-0">
              <vue-good-table
                :columns="employee_columns"
                :rows="employee_data_update"
                max-height="450px"
                :fixed-header="true"
                :sort-options="{
                  enabled:false
                }"
                :group-options="{
                  enabled: true,
                  headerPosition: 'top',
                  //collapsable: false,
                }"

              >
                <div slot="emptystate">
                  Không có dữ liệu
                </div>
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <div v-if="props.column.field === 'action'" class="checkbox-left center">
                    <div v-if="props.row.is_title != 1">
                      <vs-checkbox  v-model="props.row.checked" :value="props.row.checked" @click="checkGroupUser(props.row.employee_id)">
                      </vs-checkbox>
                    </div>
                  </div>
               </template>
              </vue-good-table>
        </CCardBody>
        <CCardFooter class="pt-1 pb-1 center">
            <vs-button square @click="saveGroupUser">
              <i class='bx bx-send'></i>&nbsp;Lưu lại
            </vs-button>
        </CCardFooter>
      </CCard>
      
    </vs-dialog>

    <vs-dialog prevent-close class="target-dialog"  width="750px"  v-model="state.dialog.target">
      <CCard  class="pb-0">
        <CCardHeader class="pt-0 pb-0">
            <h4>Danh sách chỉ tiêu</h4>
        </CCardHeader>
        <CCardBody  class="pt-2 pb-0">
              <vue-good-table
                :columns="target_columns"
                :rows="target_data_update"
                max-height="450px"
                :fixed-header="true"
                :sort-options="{
                  enabled:false
                }"
                :group-options="{
                  enabled: true,
                  headerPosition: 'top',
                  collapsable: true,
                }"
                
              >
                <div slot="emptystate">
                  Không có dữ liệu
                </div>
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <div v-if="props.column.field === 'action'" class="checkbox-left center">
                    <div v-if="props.row.is_title != 1">
                      <vs-checkbox  v-model="props.row.checked" :value="props.row.checked" @click="checkTarget(props.row)">
                      </vs-checkbox>
                    </div>
                  </div>
                  <div v-else-if="props.column.field === 'point'" class="center">
                    <div v-if="props.row.is_title != 1">
                        <CInput v-if="props.row.checked"
                          v-model="props.row.point"
                          type="number"
                          :onchange="changePoint(props.row)"
                        />
                        <!-- <span v-if="props.row.checked">+</span> -->
                        
                    </div>
                  </div>
               </template>
              </vue-good-table>
        </CCardBody>
        <CCardFooter class="pt-1 pb-1 center">
            <vs-button square @click="saveGroupTarget">
              <i class='bx bx-send'></i>&nbsp;Lưu lại
            </vs-button>
        </CCardFooter>
      </CCard>
      
    </vs-dialog>
  </div>
</template>

<style lang="scss">
    .emulation_group{
      table.vgt-table td {
        vertical-align: inherit;
        padding: 0em .75em .0em .75em;
      }
      .vgt-responsive {
        overflow-x: inherit;
      }
      .width-class{
        min-width: 3px !important;
      }
      .width-status{
        min-width: 10px !important;
      }
      .vs-checkbox-content{
        align-items: center;
        justify-content: center;
      }
      .checkbox-left{
        text-align: left;
      }
    }
    .employee-dialog{
        padding-top:10px;
      table.vgt-table td {
        vertical-align: inherit;
        padding: 0em .75em .0em .75em;
      }
    }
    .target-dialog{
        padding-top:10px;
      table.vgt-table td {
        vertical-align: inherit;
        padding: 0em .75em .0em .75em;
      }
      .checkbox-left{
        text-align: left;
      }
    }
</style>